import React, { useState } from 'react'

import { navigate } from 'raviger'

import { useInput, runOnEnter } from 'Helpers'

import { login } from 'Store/user'

import { User as UserIcon, Lock as PasswordIcon } from 'react-feather'

import Input from 'Components/shared/Input'
import { Flex } from 'lese'
import { H2, ErrorText } from 'Components/shared/Typography'
import { Button } from 'Components/shared/Button'

export default () => {
  const [errorText, setErrorText] = useState('')

  const usernameHook = useInput('')
  const passwordHook = useInput('')

  /* 
  BUG: Currently with Google Chrome we are blocking the login cookie which we
  are getting from the backend. This is causing the attempt login to be
  successful but unable to navigate.

  FIX: Temporary fix is to set the login cookie to SameSite: Lax instead of
  Strict. Need to test in staging environment to test if it works.
*/
  const attemptLogin = async () => {
    const response = await login({
      username: usernameHook.value,
      password: passwordHook.value
    }).catch(err => {
      if (!err.response?.data?.message)
        return setErrorText(
          'There appears to be an issue with the server. Please contact a system administrator.'
        )
      setErrorText(err.response.data.message)
    })
    if (!response) return
    navigate('/')
  }

  return (
    <>
      <H2>Login</H2>
      <Flex column separation="20px">
        <Input
          Icon={UserIcon}
          placeholder="Username"
          onKeyDown={runOnEnter(attemptLogin)}
          {...usernameHook.bind}
        />
        <Input
          type="password"
          Icon={PasswordIcon}
          placeholder="Password"
          onKeyDown={runOnEnter(attemptLogin)}
          {...passwordHook.bind}
        />
      </Flex>

      <Button onClick={attemptLogin}>Login</Button>
      {errorText && <ErrorText align>{errorText}</ErrorText>}
    </>
  )
}
